enum SocialPlateforms {
  TWITTER = 'twitter',
  WHATSAPP = 'whatsapp',
  INSTAGRAM = 'instagram',
  TIKTOK = 'tiktok',
  LINE = 'line',
  FACEBOOK = 'facebook-f',
  WECHAT = 'weixin',
  EMAIL = 'envelope',
  LINK = 'link',
  LINK_COPIED = 'check',
  MORE = 'ellipsis',
}
export { SocialPlateforms };
